import Tooltip from "@atlaskit/tooltip";
import CheckCircleIcon from "@atlaskit/icon/glyph/check-circle";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import EditorErrorIcon from "@atlaskit/icon/glyph/editor/error";
import Spinner from "@atlaskit/spinner";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import { jobStatus } from "../../constants/constants";
export const createHead = (withWidth) => {
  return {
    cells: [
      {
        key: "id",
        content: <div style={{ textAlign: "center" }}>Status</div>,
        isSortable: false,
        width: withWidth ? 5 : undefined,
      },
      {
        key: "event",
        content: "Original config name",
        isSortable: false,
        width: withWidth ? 45 : undefined,
      },
      {
        key: "action",
        content: "New config name",
        isSortable: false,
        width: withWidth ? 10 : undefined,
      },
      {
        key: "action",
        content: "Status code",
        isSortable: false,
        width: withWidth ? 10 : undefined,
      },
    ],
  };
};

function createKey(input) {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
}

export const createCells = (restoreConfigDetails) =>
  restoreConfigDetails.map((data, index) => ({
    key: `row-${index}`,
    cells: [
      {
        key: createKey(data.configRestoreStatus.toString()),
        content: (
          <div style={{ textAlign: "center" }}>
            <Tooltip
              content={jobStatus[data.configRestoreStatus]}
              position="left"
            >
              <div>
                {data.configRestoreStatus === 1 && (
                  <EmojiFrequentIcon size="small" />
                )}
                {data.configRestoreStatus === 2 && <Spinner size="small" />}
                {data.configRestoreStatus === 3 && (
                  <CheckCircleIcon primaryColor="green" size="small" />
                )}
                {data.configRestoreStatus === 4 && (
                  <WarningIcon primaryColor="orange" size="small" />
                )}
                {data.configRestoreStatus === 5 && (
                  <EditorErrorIcon primaryColor="red" size="small" />
                )}
              </div>
            </Tooltip>
          </div>
        ),
      },
      {
        key: createKey(data.originalId ?? "-".toString()),
        content: <div>{data.originalId ?? "-"}</div>,
      },

      {
        key: createKey(data.newId ?? "-".toString()),
        content: data.newId ?? "-",
      },
      {
        key: createKey("321" ?? "-".toString()),
        content: (
          <div>{data.statusCodes === null ? "-" : data.statusCodes}</div>
        ),
      },
    ],
  }));
